// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-page__wrapper .article-page__article[data-v-8cfcf9bc]{width:100%}", ""]);
// Exports
module.exports = exports;
